import { ActionReducerMap } from "@ngrx/store";

import { pathReducer } from "./store/path/path.reducer";
import { PathData } from './store/path/path.data';
import { historyReducer } from './store/history/history.reducer';
import { BuilderData } from './store/builder/builder.data';
import { builderReducer } from './store/builder/builder.reducer';
import { listUsersReducer } from './store/listUsers/listUsers.reducer';
import { ListUsers } from './store/listUsers/listUsers.data';
import { ListProjects } from './store/listProjects/listProjects.data';
import { listProjectsReducer } from './store/listProjects/listProjects.reducer';


export interface AppState {
	uiPath: PathData,
	holdHistory: any[],
	builder: BuilderData,
	listUsers: ListUsers,
	listProjects: ListProjects,
}

export const appReducers: ActionReducerMap<AppState> = {
	uiPath: pathReducer,
	holdHistory: historyReducer,
	builder: builderReducer,
	listUsers: listUsersReducer,
	listProjects: listProjectsReducer,
}